/**
 * 支払い方法ごとの金額を −／＋ で増減する（純粋関数）
 *
 * - 押した支払い方法を unit（paymentMethods.unit）ずつ増減し、差分を相手の支払い方法で吸収する
 *   - 相手: 押したのが既定（is_default）以外なら既定、既定なら最初の既定でない支払い方法
 * - 合計は常に変えない。増やせるのは相手の今の金額まで、減らすときは unit 未満なら 0 にする
 *   （どの支払い方法もマイナスにならない）
 * - 支払い方法が1つ以下なら何もしない
 *
 * reservation 型の DemandOrderResult.vue の handlePMAmount と同じ考え方。こちらは金額を pm.id で持つ
 *
 * テスト: tests/unit/paymentMethodAmounts.spec.js
 */

/** 既定の支払い方法（is_default が無ければ先頭） */
export const findDefaultPaymentMethod = (paymentMethods) => {
  const pms = paymentMethods || [];
  return pms.find((pm) => Number(pm.is_default) === 1) || pms[0] || null;
};

/** 増減の幅。unit が無い・0 以下なら 1 */
const stepOf = (pm) => {
  const unit = Number(pm.unit);
  return unit > 0 ? unit : 1;
};

/**
 * @param {object} params
 * @param {Array<{id:number,is_default:number,unit:number}>} params.paymentMethods
 * @param {{[paymentMethodId:number]:number}} params.amounts 今の金額
 * @param {{id:number,unit:number}} params.target 押した支払い方法
 * @param {'plus'|'minus'} params.direction
 * @returns {{[paymentMethodId:number]:number}} 新しい金額（amounts は書き換えない）
 */
export default function adjustPaymentAmount({
  paymentMethods, amounts, target, direction,
}) {
  const next = { ...(amounts || {}) };
  const pms = paymentMethods || [];
  if (pms.length < 2 || !target) return next;

  const defaultPm = findDefaultPaymentMethod(pms);
  const partner = target.id === defaultPm.id
    ? pms.find((pm) => pm.id !== defaultPm.id)
    : defaultPm;
  if (!partner) return next;

  const now = Number(next[target.id]) || 0;
  const partnerNow = Number(next[partner.id]) || 0;
  const step = stepOf(target);

  const diff = direction === 'minus'
    ? -Math.min(step, now)
    : Math.min(step, partnerNow);
  if (!diff) return next;

  next[target.id] = now + diff;
  next[partner.id] = partnerNow - diff;
  return next;
}
